import { render, staticRenderFns } from "./DonationReport.vue?vue&type=template&id=08b634b7&"
import script from "./DonationReport.vue?vue&type=script&lang=js&"
export * from "./DonationReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "DonationReport.vue"
export default component.exports